module.exports = __webpack_public_path__ + "static/oven1-b6feb805d42f8425236e52affc718651.jpg";